













































import { Component, Vue } from "vue-property-decorator";
import CalendarSyncDialog from "@/components/kalender/CalendarSyncDialog.vue";

@Component({
    components: { CalendarSyncDialog }
})
export default class Kalender extends Vue {
    dialogSyncOpen = false;
}
